import React, { Component, PureComponent } from "react";
import Image from "react-bootstrap/Image";
import moment from "moment";
import { TotalNumberSmallDateRange } from "../reusableReports/TotalNumberSmallBox";
import { ReportsLiveChart } from "./charts/ReportsLiveChart";
import { Button, Col } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import SVG from "react-inlinesvg";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { dinerLiveReport } from "../../../../store/actions/VendorReports/vendorReportsRestaurant";
import isEmpty from "../../../../store/validation/is-Empty";

import { BarChart, Bar, XAxis, YAxis, Tooltip, Label } from "recharts";

import { ReportsStatus } from "./charts/ReportsStatus";
import { PieChart, Pie, Cell } from "recharts";

export class ReportsDashboardOne extends Component {
  constructor(props) {
    super(props);
    this.state = {
      liveReport: {},
      hourlyReport: [],
      rangeReport: [],
      totalLiveReport: 0,
      reportToDisp: {
        completed: 0,
        pending: 0,
        notseated: 0,
        rejected: 0,
        cancelled: 0,
        seated: 0,
      },
    };
  }

  componentDidMount() {
    this.getdata();
    // setInterval(() => {
    //   this.props.dinerLiveReport(Date.now());
    // }, 7000);
  }
  getdata = () => {
    this.props.dinerLiveReport(
      moment(this.props.dateFilter).format("x"),
      moment(this.props.dateTo).format("x"),
      moment(this.props.dateFrom).format("x")
    );
  };
  componentDidUpdate(prevProps) {
    if (
      prevProps.dateFilter !== this.props.dateFilter ||
      prevProps.dateTo !== this.props.dateTo ||
      prevProps.dateFrom !== this.props.dateFrom
    ) {
      this.getdata();
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    // console.log(nextProps);
    if (
      !isEmpty(nextProps.liveReport) !== nextState.liveReport ||
      !isEmpty(nextProps.hourlyReport) !== nextState.hourlyReport ||
      !isEmpty(nextProps.rangeReport) !== nextState.rangeReport
    ) {
      var completed = 0;
      var pending = 0;
      var notseated = 0;
      var rejected = 0;
      var cancelled = 0;
      var seated = 0;
      var total = nextProps.rangeReport.length;
      nextProps.rangeReport.map((data) => {
        switch (data._id) {
          case "CANCELLED":
            return cancelled++;
          case "PENDING":
            return pending++;
          case "NOTSEATED":
            return notseated++;
          case "REJECTED":
            return rejected++;
          case "COMPLETED":
            return completed++;
          case "SEATED":
            return seated++;
        }
      });
      return {
        liveReport: nextProps.liveReport,
        hourlyReport: nextProps.hourlyReport,
        rangeReport: nextProps.rangeReport,
        reportToDisp: [
          {
            name: "Active Online Offer",
            value: (completed / total) * 100,
            pax: completed,
            customClass: " box-color-greenlight",
          },
          {
            name: "Active Offline Offer",
            value: (seated / total) * 100,
            pax: seated,
            customClass: " box-color-voilet",
          },
          {
            name: "Inactive Online Offer",
            value: (cancelled / total) * 100,
            pax: cancelled,
            customClass: " box-color-lightblack",
          },
          {
            name: "Inactive Offline Offer",
            value: (rejected / total) * 100,
            pax: rejected,
            customClass: " box-color-darkred",
          },
        ],
        totalLiveReport:
          nextProps.liveReport.reservation +
          nextProps.liveReport.walkin +
          nextProps.liveReport.waitlist,
      };
    } else {
      return null;
    }
  }

  render() {
    // console.log(this.state);
    const {
      totalLiveReport,
      liveReport,
      hourlyReport,
      rangeReport,
      reportToDisp,
    } = this.state;
    return (
      <React.Fragment>
        <div
          onClick={this.props.onClick}
          className="col-12 seating-report-dashboard-live"
        >
          <div className="row">
            <Col md={12} className="d-flex justify-content-between pb-4">
              <div className="f16-700">Active Offers Report Live Dashboard</div>
              <div className="d-flex align-items-center">
                {/* <div className="f14-700 mr-3">
                  25Th Aug 2020 to 25Th Aug 2020
                </div> */}
                <div className="live-button-css">
                  <p className="live-text">Live</p>
                </div>
              </div>
              {/*<div className="d-flex align-items-end">
                 <p className="date-year-month">
                  {moment(new Date()).format("DD MMMM YYYY")}
                </p> 
              </div>*/}
            </Col>
            <Col lg={10}>
              <div>
                <ReportsLiveChart
                  iconImage={require("../../../../assets/images/UserManagement/walkin.svg")}
                  altText="Offers Record"
                  titleText="Offers Record"
                  imageClass="progress-bar-icon-imageone"
                  headingText="Online"
                  paragraphText={`Total number of People ${
                    liveReport ? liveReport.walkin : `0`
                  }`}
                  now={(liveReport.walkin / totalLiveReport) * 100}
                  progressBar="main-progress-bar-sectionfive"
                />
                <ReportsLiveChart
                  iconImage={require("../../../../assets/images/Icon/waitlist.png")}
                  altText="Offers Record"
                  titleText="Offers Record"
                  imageClass="progress-bar-icon-imagetwo"
                  headingText="Offline"
                  paragraphText={`Total number of People ${
                    liveReport ? liveReport.waitlist : `0`
                  }`}
                  now={(liveReport.waitlist / totalLiveReport) * 100}
                  progressBar="main-progress-bar-sectionsix"
                />
                {/* <ReportsLiveChart
                  iconImage={require("../../../../assets/images/Icon/reservationBlack.png")}
                  altText="Offers Record"
                  titleText="Offers Record"
                  imageClass="progress-bar-icon-imagethree"
                  headingText="Reservation"
                  paragraphText={`Total number of People ${
                    liveReport ? liveReport.reservation : `0`
                  }`}
                  now={(liveReport.reservation / totalLiveReport) * 100}
                  progressBar="main-progress-bar-sectionfour"
                /> */}
              </div>
            </Col>
            <Col lg={2}>
              <TotalNumberSmallBox
                mainBoxOne="reports-dashboard-small-boxtotal"
                displayBox="display-box-all"
                colorBoxOne="color-box-one color-green-light "
                colorBoxTwo="color-box-one color-yellow"
                colorBoxThree="color-box-one color-voilet"
                headingText="f10-400"
                valueText="f12-500 mt-2"
                walkinValue={liveReport && liveReport.walkin}
                waitlistValue={liveReport && liveReport.waitlist}
                reservationValue={liveReport && liveReport.reservation}
              />
            </Col>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
            <div className="col-12 seating-report-hourly-day">
              <div className="row">
                <Col lg={5}>
                  <div className="f16-700 pb-4">
                    Active Offer Hourly Usage Report
                  </div>
                </Col>
                <Col
                  lg={7}
                  className="pb-4 d-flex justify-content-end align-items-center"
                >
                  {/* <button type="button" className="enIconBtnGray mr-3">
                    <SVG
                      src={require("../../../../assets/images/UserManagement/left-arrow.svg")}
                      alt="seating"
                    />
                  </button>
                  <TextField
                    type="date"
                    className="w-75"
                    variant="outlined"
                    value={this.props.dateFilter}
                    onChange={this.props.onDateChange}
                  />
                  <button type="button" className="enIconBtnGray ml-3">
                    <SVG
                      src={require("../../../../assets/images/UserManagement/right-arrow.svg")}
                      alt="seating"
                    />
                  </button> */}

                  <div className="f12-700">
                    25Th Aug 2020 to <br />
                    25Th Aug 2020
                  </div>
                </Col>
                <div
                  onClick={this.props.onClick}
                  className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9"
                  style={{ cursor: "pointer" }}
                >
                  <ReportsStackedChart data={hourlyReport} />
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                  <div>
                    <p className="f10-700 mb-2">
                      {moment(new Date()).format("LT")}
                    </p>
                  </div>
                  <TotalNumberSmallBox
                    mainBoxOne="reports-dashboard-small-boxtotal"
                    displayBox="display-box-all"
                    colorBoxOne="color-box-one color-green-light"
                    colorBoxTwo="color-box-one color-yellow"
                    colorBoxThree="color-box-one color-voilet"
                    headingText="f10-400"
                    valueText="f12-500 mt-2"
                    Online={"50 Users Availed offer"}
                    Offline={"3 Users Availed offer"}
                  />
                </div>
              </div>
            </div>
          </div>
          <Col lg={4}>
            <div className="col-12 seating-report-date-range">
              <div className="row">
                <Col md={8}>
                  <div className="f16-700 pb-4">
                    Offers Report
                  </div>
                </Col>
                <Col md={4}>
                  <div className="f12-700">
                    25Th Aug 2020 to <br />
                    25Th Aug 2020
                  </div>
                  <div className="f12-400">Reporting Date</div>
                </Col>
                {/* <Col md={6}>
                  <div className="f12-500 mb-1">Starts Date</div>
                  <TextField
                    type="date"
                    className="w-100"
                    variant="outlined"
                    value={this.props.dateFrom}
                    onChange={this.props.onFromDateChange}
                  />
                </Col>
                <Col md={6}>
                  <div className="f12-500 mb-1">Ends Date</div>
                  <TextField
                    type="date"
                    className="w-100"
                    variant="outlined"
                    value={this.props.dateTo}
                    onChange={this.props.onToDateChange}
                  />
                </Col> */}
              </div>
              <ReportsDonutChart data={reportToDisp} />
            </div>
          </Col>
        </div>
      </React.Fragment>
    );
  }
}

// export default ReportsDashboardOne;

const TotalNumberSmallBox = ({
  mainBoxOne,
  displayBox,
  Online,
  Offline,
  colorBoxOne,
  colorBoxThree,
  headingText,
  valueText,
}) => {
  return (
    <React.Fragment>
      <div className={mainBoxOne}>
        <div className="p-3 border-bottom">
          <div className={displayBox}>
            <div className={colorBoxOne}></div>
            <h5 className={headingText}>Online</h5>
          </div>
          <div className="col-12 pl-1">
            <h3 className={valueText}>{Online} pax</h3>
          </div>
        </div>

        <div className="p-3">
          <div className={displayBox}>
            <div className={colorBoxThree}></div>
            <h5 className={headingText}>Offline</h5>
          </div>
          <div className="col-12 pl-1">
            <h3 className={valueText}>{Offline} pax</h3>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

class ReportsStackedChart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          name: "11am",
          Waitlist: 20,
          Reservation: 12,
          Walkin: 10,
        },
        {
          name: "12pm",
          Waitlist: 20,
          Reservation: 5,
          Walkin: 15,
        },
        {
          name: "1pm",
          Waitlist: 20,
          Reservation: 8,
          Walkin: 20,
        },
        {
          name: "2pm",
          Waitlist: 20,
          Reservation: 8,
          Walkin: 20,
        },
        {
          name: "3pm",
          Waitlist: 20,
          Reservation: 8,
          Walkin: 20,
        },
        {
          name: "4pm",
          Waitlist: 20,
          Reservation: 8,
          Walkin: 20,
        },
        {
          name: "5pm",
          Waitlist: 20,
          Reservation: 8,
          Walkin: 20,
        },
        {
          name: "6pm",
          Waitlist: 20,
          Reservation: 8,
          Walkin: 20,
        },
        {
          name: "7pm",
          Waitlist: 20,
          Reservation: 8,
          Walkin: 20,
        },
        {
          name: "8pm",
          Waitlist: 20,
          Reservation: 8,
          Walkin: 20,
        },
        {
          name: "9pm",
          Waitlist: 20,
          Reservation: 8,
          Walkin: 20,
        },
        {
          name: "10pm",
          Waitlist: 20,
          Reservation: 8,
          Walkin: 20,
        },
      ],
    };
  }
  render() {
    return (
      <React.Fragment>
        <div className="stacked-chart-content">
          <BarChart
            width={600}
            height={292}
            data={this.state.data.map((data) => {
              return {
                Group: `Online`,
                "X-value": `11 am`,
                "Y-value": "50",
              };
            })}
            margin={{ top: 0, right: 0, left: 0, bottom: 10 }}
          >
            <XAxis
              dataKey="Group"
              stroke="#707070"
              fontSize="8"
              fontFamily="Roboto-Medium"
            >
              <Label
                value="Time Slots"
                offset={-10}
                position="insideBottom"
                fontSize={13}
                fontFamily="Roboto-Regular"
              />
            </XAxis>
            <YAxis
              stroke="#707070"
              fontSize={13}
              fontFamily="Roboto-Regular"
              label={{
                value: "No. Of Users",
                angle: -90,
                position: "insideLeft",
                offset: 15,
              }}
            />
            <Tooltip />
            {/* <Legend /> */}
            <Bar
              dataKey="X-value"
              barSize={12}
              stackId="a"
              fill="#6F32C9"
              strokeWidthTop={2}
              stroke={"#fff"}
              radius={[0, 0, 5, 5]}
            />
            {/* <Bar
              dataKey="Waitlist"
              barSize={12}
              stackId="a"
              fill="#FFC350"
              strokeWidthTop={2}
              stroke={"#fff"}
            /> */}
            <Bar
              dataKey="Y-value"
              barSize={12}
              stackId="a"
              fill="#148D88"
              strokeWidthTop={2}
              stroke={"#fff"}
              radius={[5, 5, 0, 0]}
            />
          </BarChart>
        </div>
      </React.Fragment>
    );
  }
}
ReportsDashboardOne.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  liveReport: state.vendorReportsRestaurant.liveReport,
  hourlyReport: state.vendorReportsRestaurant.hourlyReport,
  rangeReport: state.vendorReportsRestaurant.rangeReport,
});

export default connect(mapStateToProps, { dinerLiveReport })(
  withRouter(ReportsDashboardOne)
);

class ReportsDonutChart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      COLORS: ["#148d88", "#6f32c9", "#757575", "#890d43"],
      STROKE: ["#fff", "#fff", "#fff", "#fff"],
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.data !== nextState.data) {
      return {
        data: nextProps.data,
      };
    }
  }
  render() {
    // console.log(this.props);
    return (
      <React.Fragment>
        <div className="row main-donut-pie-chart">
          <div className="col-lg-7 d-flex align-items-center justify-content-center">
            <div className="dount-chart-circle">
              <PieChart width={200} height={200} onMouseEnter={this.onPieEnter}>
                <Pie
                  data={this.state.data}
                  cx={80}
                  cy={80}
                  innerRadius={62}
                  outerRadius={80}
                  fill="#8884d8"
                  stroke="#8884d8"
                  strokeWidth={2}
                  paddingAngle={0}
                >
                  {this.state.data.map((entry, index) => (
                    <Cell
                      key={index}
                      fill={this.state.COLORS[index % this.state.COLORS.length]}
                      stroke={
                        this.state.STROKE[index % this.state.STROKE.length]
                      }
                    />
                  ))}
                  <Tooltip />
                </Pie>
              </PieChart>
            </div>
          </div>

          <div className="col-lg-12 mt-4">
            <div className="row">
              {this.state.data.map((data) => {
                return (
                  <div className="col-6">
                    <ReportsStatus
                      colorBox={`color-box ${data.customClass}`}
                      paratext={data.name}
                      value={data.pax ? data.pax : 0}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
